import React from "react";
import style from "./Homepage.module.css";
import { GoSearch } from "react-icons/go";
import {
    Box,
    Flex,
    Grid,
    Image,
    Select,
    Text,
    Button,
    Input,
    Circle,
} from "@chakra-ui/react";
import nIcon from "../../Images/Homepage/nIcon.png";
import { Link, Route, Routes } from "react-router-dom";
import BuyOption from "./BuyOption";
import RentOption from "./RentOption";
import CommercialOption from "./CommercialOption";
import savings from "../../Images/Homepage/savings.png";
import builderProject from "../../Images/Homepage/builderProject.png";
import saleAgree from "../../Images/Homepage/saleAgree.png";
import homeLoan from "../../Images/Homepage/homeLoan.png";
import propertySarvices from "../../Images/Homepage/propertyServices.png";
import homeInter from "../../Images/Homepage/homeInteriors.svg";
import noBrokerNri from "../../Images/Homepage/noBrokerNri.png";

import avoidBroker from "../../Images/Homepage/avoidBrokers.png"
import freeListing from "../../Images/Homepage/freeLisiting.png";
import shortlist from "../../Images/Homepage/shortlist.png";
import rentalAgree from "../../Images/Homepage/rental.png"

import building from "../../Images/Homepage/building.png"
import OurCoustomerReview from "./OurCoustomerReview";

import mobile from "../../Images/Homepage/mobile.png"
import playStore from "../../Images/Homepage/playStore.png";
import appleStore from "../../Images/Homepage/iosDownload.svg"
import { bg_image, real_estate } from "../../Utils/export";
import PropertiesSection from "./PopularOwnerProperties";
import TopProjectsSection from "./TopProjects";
import PropertySearchBar from "./searchBar";

function Homepage() {
    const [selectedOpt, setSelectedOpt] = React.useState("Buy");
    return (
        <Box>
            
            <PropertySearchBar />
            <PropertiesSection />

            <TopProjectsSection />


            <Flex
                bgColor="#384d6c"
                h="55px"
                justifyContent="center"
                alignItems="center"
                color="#fff"
                m="30px 0 5px 0"
                gap={2}
                fontSize="14px"
            >
                <Image src={savings} alt="savings" />
                <Text>
                    Do you know how much <Text as="b">loan</Text> you can get? Get maximum
                    with <Text as="b">121</Text>
                </Text>
                <a
                    // href="https://www.nobroker.in/prophub/home-loan/check-eligibility/?nbFr=HOME-BANNER-BUY&utm_medium=homepage&utm_source=desktopBanner"
                    target="_blank" rel="noreferrer"
                >
                    <Button
                        color="#464646"
                        bgColor="#fff"
                        fontSize="12px"
                        p="4px 8px"
                        h="fit-content"
                        borderRadius="4px"
                    >
                        Check Eligibility
                    </Button>
                </a>
            </Flex>
            <Flex className={style.optiosWithIcon}>
                <Box>
                    <Text>New</Text>
                    <Image src={builderProject} alt="builderProject"></Image>
                    <Text>Builder Projects</Text>
                </Box>
                <Box>
                    <Text>New</Text>
                    <Image src={saleAgree} alt="saleAgree"></Image>
                    <Text>Sale Agreement</Text>
                </Box>
                <Box>
                    <Text visibility="hidden"></Text>
                    <Image src={homeLoan} alt="homeLoan"></Image>
                    <Text>Home Loan</Text>
                </Box>
                <Box>
                    <Text visibility="hidden"></Text>
                    <Image src={propertySarvices} alt="propertySarvices"></Image>
                    <Text>Property Legal Services</Text>
                </Box>
                <Box>
                    <Text>Sale is live!</Text>
                    <Image src={homeInter} alt="homeInter"></Image>
                    <Text>Home Interiors</Text>
                </Box>
                <Box>
                    <Text visibility="hidden"></Text>
                    <Image src={noBrokerNri} alt="noBrokerNri"></Image>
                    <Text>121 for NRI’s</Text>
                </Box>
            </Flex>



            <Flex mt="30px" justifyContent="center" alignItems="center" gap={10}>
                <Text className={style.horizontalLineBox}>
                    <Text className={style.horizontalLine}></Text>
                    <Text className={style.redCircle}></Text>
                </Text>
                <Text align="center" fontSize="32px" color="#787676" minW="max-content" >
                    Why Use 121
                </Text >
                <Text className={style.horizontalLineBox}>
                    <Text className={style.redCircle}></Text>
                    <Text className={style.horizontalLine}></Text>
                </Text>
            </Flex>
            <Grid className={style.whyUseNoBroker}>
                <Box>
                    <Image src={avoidBroker} alt="avoidBroker" />
                    <Text>Avoid Brokers</Text>
                    <Text>We directly connect you to verified <br /> owners to save brokerage</Text>
                </Box>
                <Box>
                    <Image src={freeListing} alt="freeListing" />
                    <Text>Free Listing</Text>
                    <Text>Easy listing process. Also <br /> using WhatsApp</Text>
                </Box>
                <Box>
                    <Image src={shortlist} alt="shortlist" />
                    <Text>Shortlist without Visit</Text>
                    <Text>Extensive Information <br /> makes it easy</Text>
                </Box>
                <Box>
                    <Image src={rentalAgree} alt="rentalAgree" />
                    <Text>Rental Agreement</Text>
                    <Text>Assistance in creating Rental <br /> agreement & Paper work</Text>
                </Box>
            </Grid>




            <Box p="40px 0">
                <Flex justifyContent="center" alignItems="center" gap={10} w="100%">
                    <Text className={style.horizontalLineBox}>
                        <Text className={style.horizontalLine}></Text>
                        <Text className={style.redCircle}></Text>
                    </Text>
                    <Text align="center" fontSize="32px" color="#787676" minW="max-content">
                        We Make A Difference
                    </Text >
                    <Text className={style.horizontalLineBox}>
                        <Text className={style.redCircle}></Text>
                        <Text className={style.horizontalLine}></Text>
                    </Text>
                </Flex>
                <Flex textAlign="center" p="0 10%" mt="40px" justifyContent="space-between">
                    <Box>
                        <Circle size="170px" bg='white' color='#fd3752' border="2px solid #fd3752" m="0 auto 15px auto" fontSize="40px" lineHeight="170px">
                            ₹130 cr+
                        </Circle>
                        <Text fontSize="22px">Brokerage saved monthly</Text>
                    </Box>
                    <Box>
                        <Circle size="170px" bg='white' color='#fd3752' border="2px solid #fd3752" m="0 auto 15px auto" fontSize="40px" lineHeight="170px">
                            30Lakh+
                        </Circle>
                        <Text fontSize="22px">Customers Connected Monthly</Text>
                    </Box>
                    <Box>
                        <Circle size="170px" bg='white' color='#fd3752' border="2px solid #fd3752" m="0 auto 15px auto" fontSize="40px" lineHeight="170px">
                            2 Lakh+
                        </Circle>
                        <Text fontSize="22px">New Listings Monthly</Text>
                    </Box>
                </Flex>
            </Box>

            <Flex className={style.mobileIconBox}>
                <Box>
                    <Image src={real_estate} alt="mobile" className="w-[250px] " />
                </Box>
                <Box ml="120px">
                    <Text fontSize="32px" fontWeight="400" color="#fd3752">Find A New Home On The Go</Text>
                    <Box m="30px 0">
                        <Text fontSize="22px">Download our app</Text>
                        <Text fontSize="18px" fontWeight="300">Where convenience is at your fingertip</Text>
                    </Box>
                    <Flex>
                        <Text m="35px 20px 35px 0">
                            <a href="#" target="_blank" rel="noreferrer">
                                <Image src={playStore} alt="playStore" h="55px !important" w="220px" />
                            </a>
                        </Text>
                        <Text m="28px 0">
                            <a
                                href="#" target="_blank" rel="noreferrer">
                                <Image src={appleStore} alt="appleStore" h="70px !important" w="220px" />
                            </a>
                        </Text>
                    </Flex>
                </Box>
            </Flex>
        </Box>

    );
}

export default Homepage;
